import { render } from "./FormSwitcher.vue?vue&type=template&id=9ef7efe2"
import script from "./FormSwitcher.vue?vue&type=script&lang=js"
export * from "./FormSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__